import React from 'react'
import { css } from '@emotion/react'
import { spacing, colors } from '@retailer-platform/shared-components'

const dividerStyles = css({
  margin: `${spacing.X20} -${spacing.X20}`,
  border: 0,
  height: 1,
  backgroundColor: colors.GRAYSCALE.X20,
})

export const MerchandisingFormSectionDivider = () => <hr css={dividerStyles} />
